var exports = {
  "K": "stickyLineObserver__LAF_YG",
};

module.exports = exports;
